/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  SimulateAuthorization200,
  SimulateAuthorizationBody,
  SimulateCapture200,
  SimulateCaptureBody
} from './schema'



/**
 * Simulate a card authorization on a given card
 * @summary Simulate Authorization
 */
export const simulateAuthorization = (
    simulateAuthorizationBody: SimulateAuthorizationBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SimulateAuthorization200>> => {
    return axios.post(
      `/cards/simulate-authorization`,
      simulateAuthorizationBody,options
    );
  }



    export type SimulateAuthorizationMutationResult = NonNullable<Awaited<ReturnType<typeof simulateAuthorization>>>
    export type SimulateAuthorizationMutationBody = SimulateAuthorizationBody
    export type SimulateAuthorizationMutationError = AxiosError<unknown>

    export const useSimulateAuthorization = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof simulateAuthorization>>, TError,{data: SimulateAuthorizationBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof simulateAuthorization>>, {data: SimulateAuthorizationBody}> = (props) => {
          const {data} = props ?? {};

          return  simulateAuthorization(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof simulateAuthorization>>, TError, {data: SimulateAuthorizationBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Simulate capturing a transaction
 * @summary Simulate a clearing of an authorized transaction
 */
export const simulateCapture = (
    simulateCaptureBody: SimulateCaptureBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SimulateCapture200>> => {
    return axios.post(
      `/cards/simulate-capture`,
      simulateCaptureBody,options
    );
  }



    export type SimulateCaptureMutationResult = NonNullable<Awaited<ReturnType<typeof simulateCapture>>>
    export type SimulateCaptureMutationBody = SimulateCaptureBody
    export type SimulateCaptureMutationError = AxiosError<unknown>

    export const useSimulateCapture = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof simulateCapture>>, TError,{data: SimulateCaptureBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof simulateCapture>>, {data: SimulateCaptureBody}> = (props) => {
          const {data} = props ?? {};

          return  simulateCapture(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof simulateCapture>>, TError, {data: SimulateCaptureBody}, TContext>(mutationFn, mutationOptions)
    }
    